<div class="popup-comp">
	<div class="modal-header faxEmail-header-style" ngbAutofocus>
		<h4 class="modal-title">Fax or email invoices</h4>
		<!-- <span class="close-banner" aria-label="Close" (click)="closeModal()">
      </span> -->
		<span>
			<img class="close-banner" src="../../../../../assets/icons/{{baseSiteId}}/close.svg" (click)="closeModal()"
				alt="close">
		</span>
	</div>
	<div class="modal-body faxEmail-body-style">
		<div *ngIf="!isSaveComplete; else saveCompleteBody">
			<h3>Invoices selected ({{noOfInvoices}})</h3>
			<p>Please limit selections to 10 per email or fax</p>


			<form [formGroup]="emailFaxForm">
				<section class="col-12 col-xs-12 col-sm-12 col-md-12">
					<label class="inner-Headers">E-mail</label>
				</section>
				<section class="row profileRadioGrp">
					<div class="col-1 col-xs-1 col-sm-1 col-md-1">
						<input type="radio" id="radio-btn" formControlName="contactMethod" value="MAIL">
					</div>
					<div class="col-11 col-xs-11 col-sm-11 col-md-11">
						<input type="email" class="form-control text-Field-Styling" formControlName="email">
						<span *ngIf="emailFaxForm.get('email').invalid && emailFaxForm.get('email').touched">
							<span class="defaulterrormsg" *ngIf="emailFaxForm.get('email')?.errors?.required">
								E-mail is mandatory if selected
							</span>
							<span class="defaulterrormsg"
								*ngIf="emailFaxForm.get('email')?.errors?.email || emailFaxForm.get('email')?.errors?.pattern">
								Please enter a valid email address
							</span>
						</span>
					</div>
				</section>

				<section class="col-12 col-xs-12 col-sm-12 col-md-12">
					<label class="inner-Headers">Fax</label>
				</section>
				<section class="row profileRadioGrp">
					<div class="col-1 col-xs-1 col-sm-1 col-md-1">
						<input type="radio" id="radio-btn" formControlName="contactMethod" value="FAX">
					</div>
					<div class="col-11 col-xs-11 col-sm-11 col-md-11">
						<input type="text" class="form-control text-Field-Styling width-fc" formControlName="fax"
							placeholder="xxx-xxx-xxxx">
						<span *ngIf="emailFaxForm.get('fax').invalid && emailFaxForm.get('fax').touched">
							<span class="defaulterrormsg" *ngIf="emailFaxForm.get('fax')?.errors?.required">
								Fax is mandatory if selected
							</span>
							<span class="defaulterrormsg"
								*ngIf="emailFaxForm.get('fax')?.errors?.maxlength || emailFaxForm.get('fax')?.errors?.pattern">
								Please enter a valid fax number
							</span>
						</span>
					</div>
				</section>

				<section class="row mt-4 checkbox-style" *ngIf="emailFaxForm.get('contactMethod').value == 'FAX'">
					<div class="col-2 col-xs-2 col-sm-2 col-md-2"></div>
					<div class="col-10 col-xs-10 col-sm-10 col-md-10">
						<input type="checkbox" class="form-control" formControlName="coverSheet">
						<span class="checkbox-margin">Cover Sheet</span>
					</div>
				</section>

				<ng-container *ngIf="emailFaxForm.get('coverSheet').value == true">
					<section class="col-12 col-xs-12 col-sm-12 col-md-12">
						<label class="inner-Headers">Attention to
							<span class="details"> (Optional)</span>
						</label>
					</section>
					<section class="row">
						<div class="col-1 col-xs-1 col-sm-1 col-md-1"></div>
						<div class="col-11 col-xs-11 col-sm-11 col-md-11">
							<input type="text" class="form-control text-Field-Styling" formControlName="attention" maxlength="35">
						</div>
					</section>

					<section class="col-12 col-xs-12 col-sm-12 col-md-12">
						<label class="inner-Headers">Comments
							<span class="details"> (Optional)</span>
						</label>
					</section>
					<section class="row">
						<div class="col-1 col-xs-1 col-sm-1 col-md-1"></div>
						<div class="col-11 col-xs-11 col-sm-11 col-md-11">
							<textarea id="comment" name="comments" maxlength="250" class="form-control text-Field-Styling" rows="2"
								formControlName="comments">
				  </textarea>
						</div>
					</section>
				</ng-container>
			</form>
		</div>
		<ng-template #saveCompleteBody>
			<section *ngIf="!errorOnSave" class="text-center">
				<img src="../../../../../assets/icons/{{baseSiteId}}/confirmation-positive-green.png"
					class="positive-green-icon">
				<span class="settings-saved">{{successMessage}}</span>
			</section>
			<section *ngIf="errorOnSave" class="text-center">
				<img src="../../../../../assets/icons/{{baseSiteId}}/confirmation-negative-red.png" class="positive-green-icon">
				<span class="settings-saved">There is a problem in sending the document(s).</span>
			</section>
		</ng-template>
	</div>
	<div class="modal-footer faxEmail-footer-style">
		<div class="change-request-btngrps">
			<button type="submit" class="btn btn-primary" [disabled]="!emailFaxForm.valid || saveClicked"
				(click)="saveDetails()" *ngIf="!isSaveComplete">
				<i class="fa fa-spinner fa-spin" *ngIf="saveClicked"></i>
				<span *ngIf="!saveClicked">Send</span>
			</button>
			<button type="button" class="btn btn-secondary mt-2" (click)="closeModal()">
				<span *ngIf="!isSaveComplete">Cancel</span>
				<span *ngIf="isSaveComplete">Return to order history</span>
				<!--or return to order history text-->
			</button>
		</div>
	</div>
</div>